import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import BoltIcon from '@mui/icons-material/Bolt';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import AppAppBar from '../AppAppBar';
import Footer from '../Footer';

export default function About({ mode, toggleColorMode }) {
  const features = [
    {
      icon: <EmojiObjectsIcon sx={{ fontSize: 40 }} />,
      title: "Kreative KI",
      description: "Unsere künstliche Intelligenz wurde speziell darauf trainiert, innovative und einzigartige Ideen zu generieren."
    },
    {
      icon: <BoltIcon sx={{ fontSize: 40 }} />,
      title: "Schnelle Ergebnisse",
      description: "Erhalten Sie in Sekundenschnelle kreative Vorschläge für Ihre Projekte und Herausforderungen."
    },
    {
      icon: <AutoFixHighRoundedIcon sx={{ fontSize: 40 }} />,
      title: "Personalisierte Lösungen",
      description: "Jede generierte Idee wird auf Ihre spezifischen Anforderungen und Wünsche zugeschnitten."
    }
  ];

  return (
    <React.Fragment>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container 
        component="main" 
        sx={{ 
          mt: { xs: 12, md: 14 }, 
          mb: { xs: 12, md: 14 },
          px: { xs: 2, sm: 3, md: 4 }
        }} 
        maxWidth="lg"
      >
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Über UnicornGenerator
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 6 }}>
            UnicornGenerator ist Ihre Plattform für KI-gestützte Ideengenerierung. 
            Wir kombinieren modernste künstliche Intelligenz mit kreativen Prozessen, 
            um Ihnen bei der Entwicklung innovativer Ideen zu helfen.
          </Typography>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper 
                  elevation={0} 
                  sx={{ 
                    p: 4, 
                    height: '100%',
                    backgroundColor: 'background.default',
                    border: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <Box sx={{ color: 'primary.main', mb: 2 }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ mt: 8 }}>
            <Typography variant="h5" gutterBottom>
              Unsere Mission
            </Typography>
            <Typography variant="body1" paragraph>
              Wir glauben daran, dass jeder Mensch kreatives Potenzial hat. 
              Unsere Mission ist es, dieses Potenzial mit Hilfe von KI zu entfalten 
              und Menschen dabei zu unterstützen, ihre innovativsten Ideen zu entwickeln.
            </Typography>
          </Box>
        </Box>
      </Container>
      <Footer />
    </React.Fragment>
  );
}